/*core module*/
import { NgModule, APP_INITIALIZER } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";

import { HttpClientModule } from "@angular/common/http";
/*project Component*/
import {
  AppComponent,
  //HtmlreaderDirectiveHeader,
 // HtmlreaderDirectiveFooter
} from "./app.component";
/*configuration file for the external json*/
//import { HttpService } from "./services/http.service";
import { ConfigService } from "./services/config.service";
import { ConfigLoader } from "./services/config-loader";
/**********************************************/
/*related to this specific project*/
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgSelectModule} from '@ng-select/ng-select';
import {MatProgressSpinnerModule, MatSpinner} from '@angular/material';
import {OrderModule} from 'ngx-order-pipe';
import { StolenCarComponent } from "./stolen-car/stolen-car.component";
import { RecaptchaModule } from "ng-recaptcha";

@NgModule({
  declarations: [
    AppComponent,
    StolenCarComponent
  ],
  imports: [
    BrowserModule, 
    BrowserAnimationsModule, 
    HttpClientModule ,  
    FormsModule, 
    ReactiveFormsModule,  
    NgSelectModule, 
    MatProgressSpinnerModule, 
    OrderModule,
    RecaptchaModule//,
    //RecaptchaFormsModule
  ],
  exports: [ ReactiveFormsModule ],
  providers: [
    ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: ConfigLoader,
      deps: [ConfigService],
      multi: true
    }
  ],

  bootstrap: [AppComponent]
})
export class AppModule {}
